import { FsEntryType } from '#filesystem/types';
import { DEFAULT_PAGE_LIMIT } from './types';
export class ListDataStoresHelper {
    dataStoresWasm;
    constructor(dataStoresWasm) {
        this.dataStoresWasm = dataStoresWasm;
    }
    async listByDataStore(dataStoreName, limit, cursor) {
        const effectiveLimit = limit ?? DEFAULT_PAGE_LIMIT;
        const result = await this.dataStoresWasm.listExternalFilesByDataStoreName(dataStoreName, effectiveLimit, cursor);
        return {
            items: result.items.map((item) => ({
                linkId: item.id,
                inodeId: item.inodeId,
                type: FsEntryType.FILE,
            })),
            nextCursor: result.nextCursor,
        };
    }
    createIterator(dataStoreName) {
        const listByDataStore = this.listByDataStore.bind(this);
        async function* generator() {
            let cursor;
            do {
                const result = await listByDataStore(dataStoreName, undefined, cursor);
                for (const item of result.items) {
                    yield item;
                }
                cursor = result.nextCursor;
            } while (cursor);
        }
        const gen = generator();
        return {
            [Symbol.asyncIterator]() {
                return this;
            },
            next: () => gen.next(),
        };
    }
}
